import React from 'react';
import { toast } from 'react-hot-toast';

type ErrorBoundaryState = {
    error: Error | null
}
export default class ErrorBoundary extends React.Component<React.PropsWithChildren, ErrorBoundaryState> {
    promiseRejectionHandler = (event) => {
        if (event.reason.message === 'Audio output device change is not supported') {
            event.stopPropagation();
            console.error(event.reason);
            return false;
        }
        this.setState({
            error: event.reason
        });
    }

    state: ErrorBoundaryState = {
        error: null
    };

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        console.error(error)
        return { error: error };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Uncaught error:", error, errorInfo);
    }

    componentDidMount() {
        // Add an event listener to the window to catch unhandled promise rejections & stash the error in the state
        window.addEventListener('unhandledrejection', this.promiseRejectionHandler)
    }

    componentWillUnmount() {
        window.removeEventListener('unhandledrejection', this.promiseRejectionHandler);
    }

    componentDidUpdate() {
        if (!this.state.error) { return; }
        const message = this.state.error?.message ? this.state.error?.message : JSON.stringify(this.state.error);
        toast.error(message);
    }

    render() {
        return this.props.children;
    }
}
